import React from 'react';
import { MapPin } from 'lucide-react';

const Venue = () => {
  return (
    <section id="venue" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">会場アクセス</h2>
          <div className="w-20 h-1 bg-blue-900 mx-auto"></div>
        </div>

        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="grid md:grid-cols-2">
            <div className="p-8 md:p-12 flex flex-col justify-center">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <MapPin className="mr-3 text-blue-900" />
                東京芸術センター 天空劇場
              </h3>
              
              <div className="space-y-6 text-gray-600">
                <div>
                  <p className="font-bold text-gray-900 mb-1">住所</p>
                  <p>〒120-0034</p>
                  <p>東京都足立区千住1-4-1 東京芸術センター21階</p>
                </div>
                
                <div>
                  <p className="font-bold text-gray-900 mb-1">最寄り駅</p>
                  <ul className="list-disc list-inside space-y-1 ml-2">
                    <li>北千住駅（西口）より徒歩約7分</li>
                    <li>千住大橋駅より徒歩約10分</li>
                  </ul>
                </div>

                <div className="pt-4">
                  <a 
                    href="https://www.art-center.jp/tokyo/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-800 underline"
                  >
                    会場公式サイトはこちら
                  </a>
                </div>
              </div>
            </div>
            
            <div className="h-96 md:h-auto bg-gray-200">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3238.6666866666665!2d139.79999999999998!3d35.74999999999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188e4f5f5f5f5f%3A0x5f5f5f5f5f5f5f5f!2z5p2x5Lqs6Iq46KGT44K744Oz44K_44O8!5e0!3m2!1sja!2sjp!4v1620000000000!5m2!1sja!2sjp"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen={true}
                loading="lazy"
                title="Google Maps"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Venue;
